import { GlType, RegulatoryType } from '~/types/account';

export const glTypeLabel = (code: GlType | string): string =>
  `components.ra.fields.GlTypeIcon.${code}`;

export const regulatoryTypeLabel = (code: RegulatoryType | string): string =>
  `components.ra.fields.RegulatoryType.${code}`;
